"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _tinymce = _interopRequireDefault(require("tinymce/tinymce"));
var _utils = require("../../styles/utils");
var _utils2 = require("./utils");
var _constants = require("../../utils/constants");
var _constants2 = require("./constants");
var _color = _interopRequireDefault(require("color"));
var Styles = _tinymce["default"].html.Styles();
var $ = _tinymce["default"].dom.DomQuery;
var AVAILABLE_SCHEMAS = ['http://', 'https://', '//'];
var INTERNAL_IMAGES = ['https://assets.edison.tech/onmail/photo-loading.png'];
var _default = exports["default"] = function _default(editor, _ref) {
  var onLoadInlineImage = _ref.onLoadInlineImage,
    onLoadExternalImage = _ref.onLoadExternalImage,
    appearanceModeRef = _ref.appearanceModeRef;
  editor.parser.addAttributeFilter('bgcolor', function (nodes) {
    nodes.forEach(function (node) {
      if (appearanceModeRef.current === _constants.themeMode.LIGHT) return;
      var bgColor = node.attr('bgcolor');
      if ((0, _utils2.isValidColor)(bgColor)) {
        var baseBackgroundColor = _constants2.THEME_BACKGROUND_COLORS[appearanceModeRef.current];
        var reversedBackgroundColor = (0, _utils.reverseBackgroundColor)(bgColor, baseBackgroundColor);
        node.attr('data-bgcolor', bgColor);
        node.attr('bgcolor', reversedBackgroundColor.hex());
      }
    });
  });
  editor.parser.addAttributeFilter('style', function (nodes) {
    nodes.forEach(function (node) {
      if (appearanceModeRef.current === _constants.themeMode.LIGHT) return;
      var style = Styles.parse(node.attr('style'));
      var origFontColor = style.color;
      if ((0, _utils2.isValidColor)(origFontColor)) {
        var baseColor = _constants2.THEME_COLORS[appearanceModeRef.current];
        var reversedFontColor = (0, _utils.reverseFontColor)(origFontColor, baseColor);
        node.attr('data-color', origFontColor);
        (0, _utils2.applyNodeStyle)(Styles, node, {
          color: reversedFontColor
        });
      }
      var origBackgroundColor = style['background-color'] || style['background'];
      if (!origBackgroundColor) return;
      if ((0, _utils2.isValidColor)(origBackgroundColor)) {
        if ((0, _color["default"])(origBackgroundColor).hex() === (0, _color["default"])(_constants2.HIGHLIGHT_LIGHT_COLOR).hex()) {
          (0, _utils2.applyNodeStyle)(Styles, node, {
            'background-color': _constants2.HIGHLIGHT_DARK_COLOR
          });
          return;
        }
        var baseBackgroundColor = _constants2.THEME_BACKGROUND_COLORS[appearanceModeRef.current];
        var reversedBackgroundColor = (0, _utils.reverseBackgroundColor)(origBackgroundColor, baseBackgroundColor);
        node.attr('data-background-color', origBackgroundColor);
        (0, _utils2.applyNodeStyle)(Styles, node, {
          'background-color': reversedBackgroundColor
        });
      }
    });
  });
  editor.parser.addAttributeFilter('src', function (nodes, name) {
    nodes.forEach(function (node) {
      if (node.name !== 'img') return;
      var src = node.attr('src');
      if (!src) return;

      // Remove attribute
      if (src.startsWith('data:')) {
        node.attr('data-mce-src', null);
        return;
      }
      if (src.startsWith('cid:')) {
        var cid = src.slice(4);
        node.attr('data-cid', src.slice(4));
        node.attr('src', null);
        onLoadInlineImage(cid).then(function (url) {
          if (!url) return;
          editor.undoManager.ignore(function () {
            $("img[data-cid=\"".concat(cid, "\"]"), editor.getBody()).attr('src', url).on('load', function () {
              (0, _utils2.autoResizeHandler)(editor);
            });
          });
        });
      } else if (AVAILABLE_SCHEMAS.some(function (item) {
        return src.startsWith(item);
      })) {
        if (INTERNAL_IMAGES.includes(src) || src.match(_constants.SIGNATURE_LINK_REGEXP)) return;
        if (!onLoadExternalImage) return;
        var proxySrc = onLoadExternalImage(src);
        if (proxySrc === src) return;
        node.attr('data-src', src);
        node.attr('src', proxySrc);
        setTimeout(function () {
          var $node = $("img[data-src=\"".concat(src, "\"]"), editor.getBody());
          var errorHandler = function errorHandler() {
            $node.attr('src', src);
            $node.off('error', errorHandler);
          };
          $node.on('error', errorHandler);
        });
      }
    });
  });
};
//# sourceMappingURL=parser.js.map